<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <v-card-text>
          <v-container>
            <h2>Zoom Class Schedule for Timezone {{ friendlyTimezone }}</h2>
            <p>Need to change timezones? Select the nearest location: <a @click="changeTimezone('America/Los_Angeles')">Los Angeles</a>, <a @click="changeTimezone('America/Denver')">Denver</a>, <a @click="changeTimezone('America/New_York')">New York</a>, <a @click="changeTimezone('America/Santiago')">Santiago</a>, <a @click="changeTimezone('Europe/London')">London</a>, <a @click="changeTimezone('Asia/Kolkata')">India Standard Time (IST)</a>, <a @click="changeTimezone('Asia/Riyadh')">Saudi Arabia</a>, <a @click="changeTimezone('Asia/Seoul')">South Korea</a>, <a @click="changeTimezone('Australia/Sydney')">Sydney</a></p>
            <vue-good-table
              :columns="columns"
              :rows="rows"
              :sort-options="{
                enabled: false,
              }"
              :search-options="{
                enabled: true,
                placeholder: 'Search classes. Try searching turns, Progressing Ballet Technique, beginner, pointe, deep dive, speed barre, center, etc',
              }"
              :group-options="{
                enabled: true
              }"
              :row-style-class="rowStyleClassFn"
              styleClass="vgt-table condensed"
            >
              <div slot="emptystate">
                No classes match your search!
              </div>
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span v-if="props.column.field == 'gcal' && !props.row.name.includes('---')">
                  <v-btn
                    outlined
                    target="_blank"
                    :href="calendarLinkForClass(props.row)"
                  >
                    <v-icon>mdi-calendar-plus</v-icon> Add
                  </v-btn>
                </span>
                <span v-if="props.column.field == 'join' && !props.row.name.includes('---')">
                  <v-btn
                    outlined
                    href="https://zoom.us/j/7205932073?pwd=WnJCVmo1UGNOemdvazR3L2hOSEEzUT09"
                    target="_blank"
                  >
                    <v-icon>mdi-video</v-icon> Join
                  </v-btn>
                </span>
                <span v-if="props.column.field =='name'">
                  <span v-if="props.row.name.includes('---')"></span>
                  <span v-else>
                    <span class="mobile">{{ props.row.time }}<br></span>
                    <span class="name">{{ props.row.name }}</span>
                    <span
                      v-if="props.row.description"
                      class="more-info"
                    >
                       <br /><v-icon>mdi-information-outline</v-icon> Details:<i> {{ descriptionForClass(props.row.description) }}</i>
                    </span>
                    <span
                      v-if="props.row.pacing"
                      class="more-info"
                    >
                      <br /><v-icon> {{ speedometerIconSVG }}</v-icon> Class pace:<i> {{ pacingForClass(props.row.pacing) }}</i>
                    </span>
                    <span
                      v-if="props.row.pointe === 'Y'"
                      class="more-info"
                    >
                      <br /><v-icon>{{ pointeShoeIconSVG }}</v-icon> <i>Designed for ballet slippers, but OK for pointe shoes (for 16-week pointe program graduates)</i>
                    </span>
                    <span
                      :class="showJoinClass ? '' : 'hidden'"
                      class="mobile"
                    >
                      <br>
                      <v-btn
                        outlined
                        href="https://zoom.us/j/7205932073?pwd=WnJCVmo1UGNOemdvazR3L2hOSEEzUT09"
                        target="_blank"
                      >
                        <v-icon>mdi-video</v-icon> Join on Zoom
                      </v-btn>
                      <v-btn
                        outlined
                        target="_blank"
                        :href="calendarLinkForClass(props.row)"
                      >
                        <v-icon>mdi-calendar-plus</v-icon> Add to Google Calendar
                      </v-btn>
                    </span>
                  </span>
                </span>
                <span v-else-if="!props.row.name.includes('---')">
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
            <br />
            <h3>View More Dates</h3>
            <br />
            <v-btn-toggle
              v-model="toggleWeek"
              color="indigo accent-3"
            >
              <v-btn @click="changeWeek(thisWeek)">{{ dayAndMonth(thisWeek.startDate) }} - {{ dayAndMonth(thisWeek.endDate) }}</v-btn>
              <v-btn @click="changeWeek(week2)">{{ dayAndMonth(week2.startDate) }} - {{ dayAndMonth(week2.endDate) }}</v-btn>
              <v-btn @click="changeWeek(week3)">{{ dayAndMonth(week3.startDate) }} - {{ dayAndMonth(week3.endDate) }}</v-btn>
              <v-btn @click="changeWeek(week4)">{{ dayAndMonth(week4.startDate) }} - {{ dayAndMonth(week4.endDate) }}</v-btn>
            </v-btn-toggle>
          </v-container>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
  @media (min-width: 701px) {
    .mobile {
      display: none;
    }
  }
  .hidden {
    display:none;
  }

  .theme--light.v-btn {
    color: #267E7D;
  }

  .vgt-table, v-btn {
    font-family: Fanwood Text;
  }

  .vgt-table thead {
    font-size: 1.2em !important;
  }

  .vgt-row-header {
    color: #606266;
    font-size: 22px;
  }

  .timezone {
    font-weight: normal !important;
    font-style: italic;
  }

  .clickable {
    cursor:pointer;
  }

  a.clickable {
    color: #6acecd;
    text-decoration: underline;
  }

  .rectangle-option {
    border: 2px solid #267e7d;
    padding: 13px;
    margin-top:10px;
    font-family: proxima-nova;
    font-size: 17px;
    text-transform: none;
    letter-spacing: 1px;
    font-weight: 600;
    font-style: normal;
  }

  h2 {
    font-family: Quattrocento;
    font-weight: 400;
    font-style: normal;
    font-size: 39px;
    letter-spacing: -.02em;
    line-height: 1em;
    text-transform: none;
  }

  p, li {
    font-family: Fanwood Text;
    font-weight: 400;
    font-style: normal;
    font-size: 19px;
    letter-spacing: .01em;
    line-height: 1.7em;
    text-transform: none;
    color: rgba(40,26,23,.6);
    line-height: 1.7em;
    color: rgba(40,26,23,.6);
  }

  hr {
    border-radius: 5px;
    border: 1px dashed #267e7d;
    margin: 12px 0;
    width: 15%;
  }

  tr.divider {
    background-color: #fbfbfb;
  }

  .name {
    font-size: 1.1em;
    font-weight: 600;
  }

  .more-info {
    font-style: italic;
    color: grey;
  }

  .more-info i.mdi {
    font-size: 1.2em !important;
  }

  .more-info .v-icon__svg {
    height: 20px;
    width: 20px;
  }
</style>

<script>
  import moment from 'moment-timezone'
  import { getTimeZones } from '@vvo/tzdb'
  import 'vue-good-table/dist/vue-good-table.css'
  import { VueGoodTable } from 'vue-good-table'
  import { mdiShoeBallet, mdiSpeedometerMedium } from '@mdi/js'

  export default {
    components: {
      VueGoodTable
    },
    data () {
      return {
        showNightClasses: {},
        timezone: null,
        showJoinClass: false,
        upcomingBalletClasses: [],
        middleOfNightClasses: [],
        pointeShoeIconSVG: mdiShoeBallet,
        speedometerIconSVG: mdiSpeedometerMedium,
        toggleWeek: 0,
        thisWeek: { number: 0 },
        week2: { number: 1 },
        week3: { number: 2 },
        week4: { number: 3 },
        pacing: {
          'follow-along': 'Follow-along. No (or minimal) choreography or counts, simply follow-along.',
          'conditioning': 'Follow-along. Quick explanation of exercise, then away we go!',
          'slow': 'Slow. Lots of explanations and details.',
          'moderate': 'Moderate. Moderate pace with occasional explanations for particularly tricky combos and concepts.',
          'express': 'Express. Minimal explanations and very short breaks between combinations. Mostly dancing with very little instruction. Great for practicing picking up combinations quickly, memorization, and practice applying corrections on your own.',
          'lecture': 'Lecture. Sit, watch, learn, and ask questions.'
        },
        descriptions: {
          'jumps': 'Jumps are not recommended if you have ceramic tile or concrete flooring. For wood flooring, jumps can be lower impact by wearing jazz sneakers.',
          'upper-back': 'Must be comfortable lying on stomach & no active shoulder injuries.',
          'happy-knees': 'Recommended pain-free knee joints and able to execute a fondu on a single leg without pain.',
          'pbt-large-band': 'Using large exercise ball & theraband of any length.',
          'pbt-ball-level-2': 'Using large exercise ball. Recommended familiar with PBT bridge technique.',
          'pbt-balls': 'Using large exercise ball & small fusion ball',
          'wrist-weight-bearing-yes': 'Will be weight-bearing on wrist & shoulder.',
          'wrist-weight-bearing-no': 'No weight-bearing on wrist or shoulder.',
          'arrive-warmed-up': 'Please arrive warmed up',
          'rel-passe-center': 'Recommended comfortable with rélevé passé in center.',
          'tricky': 'Bring a big smile and be ready for brain teasers!',
          'basics': ' Great for slow methodical technique practice, whether you\'re still learning the movements or working to refine your technique.',
          'pointe-level-2': 'Recommended graduated 16-week pointe cohort or equivalent: Able to do scoop sous-sus, échappé, rélevé passé, single leg rélevé, pas de bourrée, piqué ballonné.',
          'int-pointe-class': 'Recommended comfortable (or willing to try without significant instruction) with more complex pointe combos at barre and in center.',
          'int-pointe-center': 'Recommended comfortable (or willing to try without significant instruction) with tombé pas de bourrée, échappé 2nd & 4th, rélevé passé, soutenu in center.',
          'low-chair': 'Must arrive warmed up. Have a low chair handy to put your leg on.',
          'flexibility-splits-level': 'Must arrive thoroughly warmed up. Recommended able to touch toes & weight bear on wrists. If far from splits, 2 yoga blocks will make it much more comfortable and effective.',
          'artistry': 'Feel like a dancer with beautiful barre combinations focused on musicality, breathing, and expression.',
          'artistry-barre': 'Feel like a dancer with beautiful barre combinations focused on musicality, breathing, and expression.',
          'artistry-center': 'Feel like a dancer and express yourself with gentle movement with beautiful and heartfelt port de bras.',
          'advanced-pirouettes': 'Recommended comfortable with single pirouettes en dehors & en dedans & ready for more.',
          'beginner-pirouettes': 'Strengthen for learning your first pirouette or refine your technique to move up to multiple turns.',
          'bare-feet': 'Recommended bare feet.',
          'pointe-flat': 'Pointe dancers may join at barre or in center. Designed for pointe shoes, but may join in ballet slippers.',
          'beginner-turns': 'Understanding basic mechanics of turning. This class is designed for people without any turning experience.',
          'jumps-level': 'Must be comfortable and pain-free with single-leg plié/fondu holding onto barre.',
          'floor-barre': 'If you\'ve never tried floor barre before, give it a try! You might find yourself hooked on this incredible way to build strength, technique, and refine the details. ;) Preview the class by searching "kniaseff" in the Technique Library.',
          'beginner-variations': 'Variation great for beginner ballet dancers.',
          'rockette': 'Class will consist of a warmup, a little jazz technique, and then a Rockette-inspired precision jazz combo. If you are new to dance or to jazz, come join us and bring a big smile for anything new and tricky!',
          'masterclass': 'Come and watch, ask questions, and learn! If YOU want to be the one, email hello@brocheballet.com with subject line "PICK ME!" and email body which session you plan to attend. Dancers will be drawn at random!'
        },
        columns: [
          {
            label: 'Tags',
            field: 'tags',
            hidden: true
          },
          {
            label: 'Start Date',
            field: 'startDate',
            hidden: true
          },
          {
            label: 'End Date',
            field: 'endDate',
            hidden: true
          },
          {
            label: 'Description',
            field: 'description',
            hidden: true
          },
          {
            label: 'Pointe',
            field: 'pointe',
            hidden: true
          },
          {
            label: 'ID',
            field: 'id',
            hidden: true
          },
          {
            label: 'Pacing',
            field: 'pacing',
            hidden: true
          }
        ],
        rows: [],
        timeZoneLookup: {}
      }
    },
    computed: {
      friendlyTimezone () {
        const timeZoneAbbr = this.timeZoneLookup.find((timeZone) => {
          return this.timezone === timeZone.name
        })
        if (typeof timeZoneAbbr === 'undefined') {
          return 'America - New York'
        } else {
          return timeZoneAbbr['abbreviation']
        }
      }
    },
    created () {
      if (this.$route.query.embed) {
        this.$store.commit('setLayout', 'embed-layout')
      }
      if (this.$route.query.members) {
        this.showJoinClass = true
      }
      if (this.isMobile()) {
        this.columns.push(
          {
            label: 'Title',
            field: 'name',
            type: 'text'
          }
        )
      } else {
        this.columns.push(
          {
            label: 'Time',
            field: 'time',
            width: '160px'
          },
          {
            label: 'Title',
            field: 'name',
            type: 'text'
          }
        )
        if (this.$route.query.members) {
          this.columns.unshift(
            {
              label: 'Join on Zoom',
              field: 'join',
              width: '80px',
              filterOptions: {
                enabled: false
              }
            }
          )
          this.columns.push(
            {
              label: 'Add to Google Calendar',
              field: 'gcal',
              width: '100px',
              filterOptions: {
                enabled: false
              }
            }
          )
        }
      }
      this.timeZoneLookup = getTimeZones()
      console.log(this.timeZoneLookup)
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      console.log(this.timezone)
      if (typeof this.timezone !== 'string') {
        this.timezone = 'America/New_York'
      }
      this.thisWeek['startDate'] = moment().startOf('day')
      this.thisWeek['endDate'] = moment().endOf('week')
      this.week2['startDate'] = moment().add(7, 'days').startOf('week')
      this.week2['endDate'] = moment().add(7, 'days').endOf('week')
      this.week3['startDate'] = moment().add(14, 'days').startOf('week')
      this.week3['endDate'] = moment().add(14, 'days').endOf('week')
      this.week4['startDate'] = moment().add(21, 'days').startOf('week')
      this.week4['endDate'] = moment().add(21, 'days').endOf('week')

      this.loadClassesForWeek(this.thisWeek)
    },
    methods: {
      changeWeek (week) {
        this.toggleWeek = week.number
        this.loadClassesForWeek(week)
      },
      loadClassesForWeek (week) {
        this.$store.dispatch('loadUpcomingBalletClasses', week).then(() => {
          this.calculateUpcomingClasses()
        })
      },
      isMobile () {
        /* eslint-disable */
        var check = false
        var agentRegex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
        var regex = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i

        if (agentRegex.test(navigator.userAgent) || agentRegex.test(navigator.vendor) || agentRegex.test(window.opera)) {
          check = true
        }
        if (navigator.userAgent && regex.test(navigator.userAgent.substr(0, 4))) {
          check = true
        }
        if (navigator.vendor && regex.test(navigator.vendor.substr(0, 4))) {
          check = true
        }
        if (window.opera && regex.test(window.opera.substr(0, 4))) {
          check = true
        }
        return check
      },
      rowStyleClassFn (row) {
        if (row.mode === 'span') {
          return ''
        }
        if (this.isMiddleOfNight(row.startDate)) {
          return 'nightclass hidden'
        }
        return row.name.includes('---') ? 'divider' : ''
      },
      descriptionForClass (key) {
        return this.descriptions[key]
      },
      pacingForClass (key) {
        return this.pacing[key]
      },
      calendarLinkForClass (balletClass) {
        var calendarLink = 'https://calendar.google.com/calendar/r/eventedit?text=Ballet class with Broche Ballet'
        calendarLink += '&dates=' + moment(balletClass.startDate).format('YYYYMMDD') + 'T' + moment(balletClass.startDate).format('HHmmss')
        calendarLink += '/' + moment(balletClass.endDate).format('YYYYMMDD') + 'T' + moment(balletClass.endDate).format('HHmmss')
        calendarLink += '&ctz=' + this.timezone
        calendarLink += '&location=https://brocheonline.com/join-live-class'
        calendarLink += '&details=' + balletClass.name
        return calendarLink
      },
      justTheDay (date) {
        return moment(date).format('DD MMMM yyyy')
      },
      dayAndMonth (date) {
        return moment(date).format('MMMM D')
      },
      changeShowNightClassesForDate (date, show) {
        if (this.justTheDay(date) in this.showNightClasses) {
          this.showNightClasses[this.justTheDay(date)] = show
        }
      },
      isMiddleOfNight (date) {
        var nightStart = moment(date).set('hour', 22)
        var nightEnd = moment(date).set('hour', 5)
        return (moment(date).isAfter(nightStart) || moment(date).isBefore(nightEnd))
      },
      nightClassesForDate (date) {
        var formattedDate = this.justTheDay(date)
        if (formattedDate in this.middleOfNightClasses) {
          return this.middleOfNightClasses[formattedDate].sort(function (a, b) {
            if (b.startDate.isAfter(a.startDate)) {
              return -1
            } else {
              return 1
            }
          })
        } else {
          return []
        }
      },
      calculateUpcomingClasses () {
        var classesGroupedByDate = {}
        this.middleOfNightClasses = {}
        this.showNightClasses = {}
        this.$store.getters.upcomingBalletClasses.forEach((balletClass) => {
          var dbZoneOffset = moment(balletClass.startDate).utcOffset()
          var newZoneOffset = moment(balletClass.startDate).tz(this.timezone).utcOffset()

          var differenceinOffset = Math.abs(dbZoneOffset - newZoneOffset)
          if (dbZoneOffset < newZoneOffset) {
            var zonedStartDate = moment(balletClass.startDate).add(differenceinOffset, 'minutes')
            var zonedEndDate = moment(balletClass.endDate).add(differenceinOffset, 'minutes')
          } else {
            zonedStartDate = moment(balletClass.startDate).subtract(differenceinOffset, 'minutes')
            zonedEndDate = moment(balletClass.endDate).subtract(differenceinOffset, 'minutes')
          }
          var balletClassDay = this.justTheDay(zonedStartDate)

          if (!(balletClassDay in this.showNightClasses)) {
            this.$set(this.showNightClasses, balletClassDay, false)
          }

          if (this.isMiddleOfNight(zonedStartDate)) {
            if (!(balletClassDay in this.middleOfNightClasses)) {
              this.middleOfNightClasses[balletClassDay] = []
            }
            this.middleOfNightClasses[balletClassDay].push({
              date: balletClassDay,
              startDate: zonedStartDate,
              endDate: zonedEndDate,
              name: balletClass.name,
              description: balletClass.description,
              pointe: balletClass.pointe,
              pacing: balletClass.pacing,
              tags: balletClass.tags,
              balletClassId: balletClass.balletClassId
            })
          } else {
            if (!(balletClassDay in classesGroupedByDate)) {
              classesGroupedByDate[balletClassDay] = []
            }
            classesGroupedByDate[balletClassDay].push({
              date: balletClassDay,
              startDate: zonedStartDate,
              endDate: zonedEndDate,
              name: balletClass.name,
              description: balletClass.description,
              pointe: balletClass.pointe,
              pacing: balletClass.pacing,
              tags: balletClass.tags,
              balletClassId: balletClass.balletClassId
            })
          }
        })

        var sortedBalletClasses = []
        Object.keys(classesGroupedByDate).sort(function (a, b) {
          if (moment(b).isAfter(moment(a))) {
            return -1
          } else {
            return 1
          }
        }).forEach((date) => {
          var classesSortedByTime = []
          classesSortedByTime = classesGroupedByDate[date].sort(function (a, b) {
            if (b.startDate.isAfter(a.startDate)) {
              return -1
            } else {
              return 1
            }
          })
          sortedBalletClasses.push(classesSortedByTime)
        })
        this.upcomingBalletClasses = sortedBalletClasses
        this.rows = []
        var previousClassEndTime = null
        this.upcomingBalletClasses.forEach((day) => {
          var balletClassesforDay = []
          day.forEach((balletClass) => {
            if (previousClassEndTime) {
              const gap = Math.abs(moment(previousClassEndTime).diff(moment(balletClass.startDate), 'hours', true))
              if (gap > 1 && gap < 12) {
                balletClassesforDay.push({
                  name: '-----------',
                  startDate: balletClass.startDate,
                  endDate: balletClass.startDate
                })
              }
            }
            previousClassEndTime = balletClass.endDate
            balletClassesforDay.push({
              id: balletClass.balletClassId,
              description: balletClass.description,
              pointe: balletClass.pointe,
              pacing: balletClass.pacing,
              tags: balletClass.tags,
              name: balletClass.name,
              startDate: balletClass.startDate,
              endDate: balletClass.endDate,
              time: this.formatTimes(balletClass.startDate, balletClass.endDate)
            })
          })
          this.rows.push({
            mode: 'span',
            label: this.formatDayOfWeek(day[0].startDate) + ' (in ' + this.friendlyTimezone + ' timezone)',
            children: balletClassesforDay
          })
        })
      },
      changeTimezone (newTimezone) {
        this.timezone = newTimezone
        this.calculateUpcomingClasses()
      },
      formatTimes (startDate, endDate) {
        var timeString = ''
        if (startDate !== undefined && endDate !== undefined) {
          const startDateAM = moment(startDate).format(' a')
          const endDateAM = moment(endDate).format(' a')
          const formattedStartTime = moment(startDate).format('h:mm')
          const formattedEndTime = moment(endDate).format('h:mm ')

          timeString += formattedStartTime

          if (startDateAM !== endDateAM) {
            timeString += startDateAM
          }

          timeString += ' - ' + formattedEndTime + endDateAM
        }
        return timeString
      },
      formatDayOfWeek (date) {
        if (date !== undefined) {
          const formattedDate = moment(date).format('MMMM D, yyyy')
          const days = ['Sunday', 'Monday', 'Tutu & Tunic Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Sparkle Saturday']

          return days[date.format('d')] + ' ' + formattedDate
        }
        return ''
      }
    }
  }
</script>
